import { render, staticRenderFns } from "./UploadInvoiceForm.vue?vue&type=template&id=023063bc&scoped=true"
import script from "./UploadInvoiceForm.vue?vue&type=script&lang=js"
export * from "./UploadInvoiceForm.vue?vue&type=script&lang=js"
import style0 from "./UploadInvoiceForm.vue?vue&type=style&index=0&id=023063bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023063bc",
  null
  
)

export default component.exports